export enum EFeedbackWidgetActivationSource {
  unknown = 'unknown',
  footerEntry = 'footer_entry',
  widgetButton = 'widget_button',
}
